/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 3/27/15.
 */
'use strict';
angular.module('prism-ui.package').controller('PackageManagerController',
    function (
        _,
        $location,
        $q,
        $scope,
        uiGridConstants,
        BreadcrumbService,
        DownloadAssetService,
        GridService,
        ModalService,
        NavbarUtilService,
        NotificationService,
        PackageActionService,
        PackageManagerViewDataTransformer,
        PackageMediaResourceFactory,
        PackageResourceFactory,
        PaginationService,
        PartnerPackagesService,
        PermissionsService,
        ReportViewService,
        SearchFilterService
    ) {

		var self = this;

		PartnerPackagesService.clearInstanceSelections();

		var COLUMNS_KEY_NAMES = {
		    'basic': 'package#basic',
            'detailed': 'package#detailed',
            'status': 'package#status'
        };

		// View Permissions
		var PACKAGE_SEARCH_VIEW_STATE = 'PACKAGE_SEARCH_VIEW_STATE';
		var META_TAB_VIEW_STATE = 'PACKAGE_METADATA_VIEW_STATE';
		var PACKAGE_ADVANCED_METADATA_VIEW_STATE = 'PACKAGE_ADVANCED_METADATA_VIEW_STATE';
		var COLLABORATORS_TAB_VIEW_STATE = 'PACKAGE_COLLABORATORS_VIEW_STATE';
		var MEDIA_TAB_VIEW_STATE = 'PACKAGE_MEDIA_VIEW_STATE';
		var PREVIEW_TAB_VIEW_STATE = 'PACKAGE_VIDEO_PREVIEW_VIEW_STATE';
		var BATCH_CLONE_STATE = 'PACKAGE_BATCH_CLONE_VIEW_STATE';
		var CLONE_STATE = 'PACKAGE_CLONE_VIEW_STATE';
		var CLIP_TABS_VIEW_STATE = 'PACKAGE_VIDEO_CLIPS_VIEW_STATE';

		var parentPackageChildren = {};
		self.pmPerms = {
			read: false,
			write: false,
			clone: {
				read: false,
				write: false,
				batch: {
					write: false
				}
			},
			preview: {
				read: false
			}
		};
		var editView = ''; //Set upon permissions evaluation

		self.actionsEnabled = false;
		self.includeArchived = false;
		self.unhideInvalid = self.hideInvalid = true;
		var enableHideUnhide = function () {
			var archivedFound = false;
			var unarchivedFound = false;
			if (self.selectedPackages.length === 0 || !self.pmPerms.write) {
				self.hideInvalid = self.unhideInvalid = true;
				return;
			}

			for (var idx in self.selectedPackages) {
				var pkg = self.selectedPackages[idx];
				if (pkg.hidden) {
					archivedFound = true;
				}
				else {
					unarchivedFound = true;
				}
				if (unarchivedFound && archivedFound) {
					self.hideInvalid = self.unhideInvalid = true;
					return;
				}
			}
			if (unarchivedFound) {
				self.unhideInvalid = true;
				self.hideInvalid = false;
			}
			else {
				self.unhideInvalid = false;
				self.hideInvalid = true;
			}
		};

		var enableClone = function () {
			var length = self.selectedPackages.length;

			self.canClone = (length >= 1 && self.pmPerms.clone.batch.write) || (self.pmPerms.clone.write && length === 1);
		};

		var enableActions = function () {
			var enable = !!self.selectedPackages.length;
			angular.forEach(self.selectedPackages, function (pkg) {
				if (pkg.locked) {
					enable = false;
				}
			});

			self.actionsEnabled = enable;
		};

		var enableToolbarItems = function () {
			enableHideUnhide();
			enableClone();
			enableActions();
		};

		let updateToolbarAndResetActions = () => {
            PackageActionService.handleGridItemSelection();
            enableToolbarItems();
        };

        self.gridRowBatchSelectionChangedHandler = (rows) => {
            self.selectedPackages = _.concat(self.selectedPackages, _.map(rows, 'entity'));
            PackageActionService.selectedPackages = self.selectedPackages;
            updateToolbarAndResetActions();
        };

		self.gridRowSelectionChangedHandler = (row) => {
			if (row.isSelected) {
				self.selectedPackages.push(row.entity);
			} else {
				var index = self.selectedPackages.indexOf(row.entity);
				self.selectedPackages.splice(index, 1);
			}
			PackageActionService.selectedPackages = self.selectedPackages;
            updateToolbarAndResetActions();
		};

		var getPackageEditIndex = function (packageObj) {
			var collection = self.currentGridOptions.data;
			var item;
			for (var i = 0; i < collection.length; i++) {
				item = collection[i];
				if (item.id === packageObj.id) {
					return i;
				}
			}

			return -1;
		};

		var openPackageEdit = function (packageToEdit) {
			if (packageToEdit.hidden) {
				NotificationService.createWarningNotification('Package is Hidden');
			} else {
				PaginationService.currentPageItemIndex = getPackageEditIndex(packageToEdit);
				BreadcrumbService.addBreadcrumb({
					location: '/packages',
					name: 'Packages - Edit',
					params: angular.copy($location.search())
				});
				if (packageToEdit.parentPackageId && editView !== '' && !packageToEdit.locked) {
					$location.url('/packages/package/edit/' + packageToEdit.parentPackageId + '/liveClip/');
					$location.search({livePackageId: packageToEdit.id});
				}
				else if (editView !== '') {
					$location.url('/packages/package/edit/' + packageToEdit.id + '/' + editView);
				}
			}
		};

		var newPackageCallback = function (newPackages) {

			var deffered = $q.defer();
			var promise;
			// If we are on page one, no need to query for grid data.
			if (self.pagingOptions.currentPage === 1) {
				newPackages.sort(function (a, b) {
					return Date.parse(b.dateCreated) - Date.parse(a.dateCreated);
				});

				var newData = newPackages.concat(self.currentGridOptions.data).slice(0, self.pagingOptions.pageSize);
				self.currentGridOptions.data = newData;
				self.pagingOptions.pageData = newData;
				deffered.resolve(newData);
				promise = deffered.promise;
			}
			else {
				// Need to make sure the retrieved data is for page one if we are entering a package on creation
				if (newPackages.length === 1) {
					self.pagingOptions.currentPage = 1;
				}
				promise = self.queryForGridData();
			}
			promise.then(function () {
				if (newPackages.length === 1 && !newPackages[0].clone) {
					openPackageEdit(newPackages[0]);
				}
				$scope.$broadcast('server-busy', {working: false});
			});
		};

		self.populateNewPackages = function (newPackageObjData) {
			$scope.$broadcast('server-busy', {working: true});
			var newPackages = [];
			newPackages.push(PackageResourceFactory.save(newPackageObjData.package).$promise);
			for (var i = 2; i <= newPackageObjData.numPackages; i++) {
				var newPackageCopy = {
					name: newPackageObjData.package.name + ' (' + (i - 1) + ')',
					content: newPackageObjData.package.content,
					categoryType: newPackageObjData.package.categoryType,
					purgeOnIngest: true,
					autoDeliver: true
				};
				newPackages.push(PackageResourceFactory.save(newPackageCopy).$promise);
			}
			$q.all(newPackages).then(function (newPackageData) {
				newPackageCallback(newPackageData);
			});
		};

		self.showActionsLoading = PackageActionService.actionsLoading;
		self.loadingIndicator = {
			backdrop: true,
			show: false,
			title: 'Working',
			message: 'Please wait...'
		};

		self.showNewPackageModal = function () {
			ModalService.showNewPackageModal(self.populateNewPackages);
		};

		$scope.$on('server-busy', function (event, options) {
			self.loadingIndicator.show = options.working;
		});

		function getColumnsKeyName() {
		    return COLUMNS_KEY_NAMES[self.currentView];
        }

		self.handleSortColumnChange = function (grid, sortColumns) {
            if (_.size(sortColumns) > 0) {
                if (_.size(sortColumns) > 1 && SearchFilterService.searchCriteria.sortProperty) {
                    var prevSortColumn = _.remove(sortColumns, function (column) {
                        return (
                            column.colDef.sortField === SearchFilterService.searchCriteria.sortProperty ||
                            column.field === SearchFilterService.searchCriteria.sortProperty);
                    })[0];
                    prevSortColumn.unsort();
                }

                SearchFilterService.searchCriteria.sortProperty = sortColumns[0].colDef.sortField || sortColumns[0].field;
                SearchFilterService.searchCriteria.sortDescending = sortColumns[0].sort.direction === uiGridConstants.DESC;
            } else {
                delete SearchFilterService.searchCriteria.sortProperty;
                delete SearchFilterService.searchCriteria.sortDescending;
            }
			self.queryForGridData();
		};

		self.defaultGridOptions = {
			selectionRowHeaderColName: 'checkMarkRowHeaderCol',
			rowSelection: true,
			enableRowHeaderSelection: false,
			enableSelectAll: true,
			enableColumnResizing: true,
			enablePaginationControls: false,
			useExternalPagination: true,
			enableColumnMenus: false,
			enableFullRowSelection: true,
			rowHeight: 26,
			multiSelect: true,
			useExternalSorting: true,
			columnDefs: PackageManagerViewDataTransformer.basicColumns,
			rowTemplate: '<div ng-dblclick="grid.appScope.searchController.rowDoubleClicked(row)" ' +
			'ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ' +
			'ng-class="row.entity.hidden ? \'ui-grid-cell-hidden\' : \'\'" class="ui-grid-cell" ui-grid-cell> ' +
			'</div>',
			onRegisterApi: function (gridApi) {
				self.gridApi = gridApi;
                GridService.manageSavedColumns($scope, self.gridApi, getColumnsKeyName);
                gridApi.selection.on.rowSelectionChanged($scope, self.gridRowSelectionChangedHandler);
                gridApi.selection.on.rowSelectionChangedBatch($scope, self.gridRowBatchSelectionChangedHandler);
				gridApi.core.on.sortChanged($scope, self.handleSortColumnChange);
			}
		};

		self.toggleRows = function (evt) {
			if (self.gridApi.selection.selectAll) {
				self.gridApi.selection.clearSelectedRows(evt);
				self.gridApi.selection.selectAll = false;
			} else {
				self.gridApi.selection.selectAllVisibleRows(evt);
				self.gridApi.selection.selectAll = true;
			}
			self.selectedPackages = self.gridApi.selection.getSelectedRows();
			PackageActionService.selectedPackages = self.selectedPackages;
			PackageActionService.handleGridItemSelection();
			enableToolbarItems();
		};

		self.selectedPackages = [];
		self.actions = PackageActionService.actions;

        var showLoadingIndicator = function () {
            $scope.$emit('server-busy', {working: true});
        };

        var hideLoadingIndicator = function () {
            $scope.$emit('server-busy', {working: false});
        };

		self.handleSelectedAction = function () {
			PackageActionService.handleSelectedAction(
			    self.selectedAction,
                showLoadingIndicator,
                hideLoadingIndicator
            );
			self.selectedAction = null;
		};

		self.pagingOptions = PaginationService;
		self.currentPageSize = self.pagingOptions.pageSize; //Need to hold local reference in order to modify to include clip packages
		PaginationService.pageDataResource = PackageResourceFactory;

		self.currentGridOptions = self.defaultGridOptions;
		self.currentView = 'basic';

		var indexColumnWidth = function () {
			return ((self.pagingOptions.pageSize * self.pagingOptions.currentPage) + '').length * 9 + 10;
		};

		var handleGridDataQuery = function (gridData, responseHeaders) {
			self.parseResponseHeaders(responseHeaders);
			PaginationService.pageData = gridData;
			self.currentPageSize = gridData.length;
			if ($location.search().hasOwnProperty('pmView') && $location.search().pmView === 'detailed') {
				angular.forEach(gridData, function (item) {
					var media = {
						video: [],
						image: [],
						cc: [],
						subtitle: [],
						adpod: [],
						audio: [],
						videocomponentmaster: []
					};

					PackageResourceFactory.query({
							id: item.id,
							sub: 'media'
						},
						function (mediaData) {
							angular.forEach(mediaData, function (mediaObj) {
								media[mediaObj.type.toLowerCase()].push(mediaObj);
								if (mediaObj.type.toLowerCase() === 'video' && mediaObj.role.isDefault) {
									item.burnedInSubtitles = PackageManagerViewDataTransformer.generateBurnedInSubtitleLanguageString(mediaObj);
									item.narrativeBurnedInText = PackageManagerViewDataTransformer.generateNarrativeBurnedInTextLanguageString(mediaObj);
									item.recapEndingTimecode = mediaObj.recapEndingTimecode;
									item.recapEndingTimecodeClean = (mediaObj.recapEndingTimecodeClean) ? 'YES' : '';
								}
							});
							item.ccLanguageRole = PackageManagerViewDataTransformer.generateLanguageRoleString(media.cc);
							item.subtitleLanguageRole = PackageManagerViewDataTransformer.generateLanguageRoleString(media.subtitle);
							item.audioLanguageRole = PackageManagerViewDataTransformer.generateLanguageRoleString(media.audio);
							item.availableComponentRoles = PackageManagerViewDataTransformer.generateAvailableComponentString(media.video);
							$scope.$broadcast('server-busy', {working: false});
						}
					);
				});
			} else {
				$scope.$broadcast('server-busy', {working: false});
			}

			// [1] = package index column
            if (self.gridApi) {
                self.gridApi.grid.columns[1].width = indexColumnWidth();
                GridService.saveCurrentColumns(self.gridApi, getColumnsKeyName);
            } else {
                self.currentGridOptions.columnDefs[1].width = indexColumnWidth();
            }

            //
            // packageIndexBase is used for calculating the row
            // numbers shown on the package manager grid.
            //
            // We buffer this value so that the row numbers don't
            // recalculate as the user is typing a page number
            // into the pagination controls.
            //
            self.packageIndexBase = self.pagingOptions.currentPage;
		};

		self.queryForGridData = function () {
			if (!self.pmPerms.read) {
				return;
			}
			$scope.$broadcast('server-busy', {working: true});

			var offset = self.pagingOptions.pageSize * (self.pagingOptions.currentPage - 1);
			self.selectedPackages = [];
			PackageActionService.selectedPackages = [];
			PackageActionService.handleGridItemSelection();
			enableToolbarItems();

			var queryOpts = {
				fetchOffset: offset,
				fetchLimit: self.pagingOptions.pageSize,
				includeHidden: self.includeArchived
			};
			angular.extend(queryOpts, SearchFilterService.searchCriteria);
			self.currentGridOptions.data = (SearchFilterService.isSearchFilterApplied() || SearchFilterService.searchCriteria.sortProperty) ?
				PackageResourceFactory.executeSearchFilter({}, queryOpts, handleGridDataQuery) :
				PackageResourceFactory.query(queryOpts, handleGridDataQuery);
			return self.currentGridOptions.data.$promise;
		};

		self.parseResponseHeaders = function (responseHeaders) {
			var headers = responseHeaders();
			var contentRange = headers['content-range'];

			if (contentRange) {
				var contentTotal = parseInt(contentRange.split('/')[1]);
				self.pagingOptions.contentTotal = contentTotal;
				self.pagingOptions.totalPages = Math.ceil(contentTotal / self.pagingOptions.pageSize);
				self.pagingOptions.totalPagesArray = [].constructor(self.pagingOptions.totalPages);
			}
		};

		self.paginationPrevPageHandler = function () {
			--self.pagingOptions.currentPage;
			self.onPaginationChanged();
		};

		self.paginationNextPageHandler = function () {
			++self.pagingOptions.currentPage;
			self.onPaginationChanged();
		};

		self.paginationJumpToPageHandler = function () {
			self.onPaginationChanged();
		};


		self.rowDoubleClicked = function (row) {
			openPackageEdit(row.entity);
		};

		self.viewQCNotes = function (row) {
			self.packageMediaQuery = PackageMediaResourceFactory.get({
					id: row.id
				},
				function (mediaData) {
					ModalService.showPackageQCNotesModal(mediaData.reverse());
				}
			);
		};

		self.toggleClipPackages = function (parentPackage, event) {
			event.preventDefault();
			event.stopImmediatePropagation();
			parentPackage.expanded = !parentPackage.expanded;
			var parentDataIndex = self.currentGridOptions.data.indexOf(parentPackage);
			if (parentPackage.expanded) {
				PackageResourceFactory.getClips({id: parentPackage.id, includeHidden: self.includeArchived}).$promise.then(function (clips) {
					parentPackageChildren[parentPackage.id] = clips;
					self.currentGridOptions.data.splice.apply(self.currentGridOptions.data, [parentDataIndex + 1, 0].concat(clips));
					self.currentPageSize += clips.length;
				});
			} else {
				self.currentPageSize -= parentPackageChildren[parentPackage.id].length;
				self.currentGridOptions.data.splice(parentDataIndex + 1, parentPackageChildren[parentPackage.id].length);
				parentPackageChildren[parentPackage.id] = null;
			}
		};

		self.onPaginationChanged = function () {
			self.queryForGridData();
		};

		self.openSelectedPackage = function () {
			openPackageEdit(self.selectedPackages[0]);
		};

		$scope.$watch(function () {
				return self.pagingOptions.pageSize;
			},
			function (newValue, oldValue) {
				if (newValue !== oldValue) {
					self.currentPageSize = newValue;
					self.onPaginationChanged();
				}
			}
		);

		self.switchView = function (currView) {
            self.currentView = currView;
			switch (currView) {
				case 'detailed' :
					self.currentGridOptions.columnDefs = PackageManagerViewDataTransformer.detailedColumns;
					break;
				case 'status' :
					self.currentGridOptions.columnDefs = PackageManagerViewDataTransformer.statusColumns;
					break;
				default :
					self.currentGridOptions.columnDefs = PackageManagerViewDataTransformer.basicColumns;
                    self.currentView = 'basic';
			}
			if (self.gridApi) {
                GridService.loadSavedColumns(self.gridApi, getColumnsKeyName);
            }
		};

		self.cloneSelectedPackages = function () {
			$scope.$broadcast('server-busy', {working: true});
			var clonePromises = [];
			angular.forEach(self.selectedPackages, function (packageObj) {
				var clone = PackageResourceFactory.clone({id: packageObj.id}, {}).$promise;
				clonePromises.push(clone);
			});
			$q.all(clonePromises).then(function (clones) {
				newPackageCallback(clones);
				$scope.$broadcast('server-busy', {working: false});
			});
		};

		self.toggleArchiveFlag = function () {
			self.unhideInvalid = self.hideInvalid = true;
			$scope.$broadcast('server-busy', {working: true});
			var promises = [];
			angular.forEach(self.selectedPackages, function (packageObj) {
				var pkg = PackageResourceFactory.toggleArchive({id: packageObj.id}).$promise;
				promises.push(pkg);
			});
			$q.all(promises).then(function (pkgs) {
				self.queryForGridData();
			});
		};

		self.hideMessage = 'Are you sure you want to hide ';
		self.unhideMessage = 'Are you sure you want to unhide ';
		self.cloneMessage = 'Are you sure you want to clone ';
		self.openConfirmModal = function (messageText, title, handler) {
			if (self.selectedPackages.length === 1) {
				messageText += self.selectedPackages[0].name + '?';
				title += self.selectedPackages[0].name + '?';
			}
			else {
				messageText += 'these items?';
				title += 'items?';
			}
			ModalService.showMessageModal({
				messageText: messageText,
                pullCancelLeft: true,
				title: title,
				windowClass: 'confirm-modal-sm',
				showOK: true
			}, handler);
		};

		$scope.$watch(function () {
				return $location.search().pmView;
			},
			function (newView) {
				if (newView) {
					self.switchView(newView);
				}
			}
		);

		var getPackagePermissions = function () {
			var packageSearchRead = PermissionsService.canRead(PACKAGE_SEARCH_VIEW_STATE);
			var packageSearchWrite = PermissionsService.canWrite(PACKAGE_SEARCH_VIEW_STATE);
			var metaPromise = PermissionsService.canRead(META_TAB_VIEW_STATE);
			var collaboratorPromise = PermissionsService.canRead(COLLABORATORS_TAB_VIEW_STATE);
			var mediaPromise = PermissionsService.canRead(MEDIA_TAB_VIEW_STATE);
			var hierarchicalPromise = PermissionsService.canRead(PACKAGE_ADVANCED_METADATA_VIEW_STATE);
			var previewPromise = PermissionsService.canRead(PREVIEW_TAB_VIEW_STATE);
			var clipsPromise = PermissionsService.canRead(CLIP_TABS_VIEW_STATE);
			var clonePromise = PermissionsService.canWrite(CLONE_STATE);
			var cloneReadPromise = PermissionsService.canRead(CLONE_STATE);
			var batchClonePromise = PermissionsService.canWrite(BATCH_CLONE_STATE);
			var batchCloneReadPromise = PermissionsService.canRead(BATCH_CLONE_STATE);
			$q.all({
				searchRead: packageSearchRead,
				searchWrite: packageSearchWrite,
				meta: metaPromise,
				collaborators: collaboratorPromise,
				media: mediaPromise,
				preview: previewPromise,
				clips: clipsPromise,
				hierarchical: hierarchicalPromise,
				clone: clonePromise,
				cloneRead: cloneReadPromise,
				batchClone: batchClonePromise,
				batchCloneRead: batchCloneReadPromise
			}).then(function (perms) {
				if (perms.meta) {
					editView = 'metadata';
				}
				else if (perms.collaborators) {
					editView = 'collaborators';
				}
				else if (perms.media) {
					editView = 'media';
				}
				else if (perms.preview) {
					editView = 'preview';
				}
				else if (perms.clips) {
					editView = 'liveClip';
				}
				else if (perms.hierarchical) {
					editView = 'hierarchicalMeta';
				}
					self.pmPerms.read = perms.searchRead;
				self.pmPerms.write = perms.searchWrite;
				self.pmPerms.clone.read = perms.cloneRead || perms.batchCloneRead;
				self.pmPerms.clone.write = perms.clone;
				self.pmPerms.clone.batch.write = perms.batchClone;
				self.pmPerms.preview.read = perms.preview;

				self.queryForGridData();
			});
		};

		NavbarUtilService.viewSearchFunction = function (searchText, forceRefresh) {
			if (forceRefresh) {
				self.pagingOptions.currentPage = 1;
			}
			self.queryForGridData();
		};

		var handleSearchFilterModalApply = function () {
			self.pagingOptions.currentPage = 1;
			SearchFilterService.updateLocationSearch();
            self.queryForGridData();
		};

		var handleSearchFilterModalCancel = function (cancelMessage) {
			if (cancelMessage === 'setToDefaults') {
				self.pagingOptions.currentPage = 1;
				SearchFilterService.resetCriteriaToDefault();
                self.queryForGridData();
			}
		};

		NavbarUtilService.viewFilterBtnHandler = function () {
			ModalService.showPMSearchFilterModal(handleSearchFilterModalApply, handleSearchFilterModalCancel);
		};

		NavbarUtilService.viewReportButtonHandlers.deliveryReport = function () {
			ModalService.showCreateReportModal(ReportViewService.availableReports[0], function (reportOptions) {
				reportOptions.filterCriteria = SearchFilterService.searchCriteria;
				ReportViewService.startReportWorkflow(ReportViewService.availableReports[0], reportOptions);
			});
		};

		NavbarUtilService.viewReportButtonHandlers.packageReport = function () {
			ModalService.showCreateReportModal(ReportViewService.PACKAGE_REPORT, function (reportOptions) {
				reportOptions.filterCriteria = SearchFilterService.searchCriteria;
				ReportViewService.startReportWorkflow(ReportViewService.PACKAGE_REPORT, reportOptions);
			});
		};

		NavbarUtilService.viewReportButtonHandlers.packageMetadataReport = function () {
			ModalService.showCreateReportModal(ReportViewService.PACKAGE_ALL_METADATA_REPORT, function (reportOptions) {
				reportOptions.filterCriteria = SearchFilterService.searchCriteria;
				ReportViewService.startReportWorkflow(ReportViewService.PACKAGE_ALL_METADATA_REPORT, reportOptions);
			});
		};

		NavbarUtilService.viewReportButtonHandlers.packageMediaReport = function () {
			ModalService.showCreateReportModal(ReportViewService.PACKAGE_MEDIA_REPORT, function (reportOptions) {
				reportOptions.filterCriteria = SearchFilterService.searchCriteria;
				ReportViewService.startReportWorkflow(ReportViewService.PACKAGE_MEDIA_REPORT, reportOptions);
			});
		};

        NavbarUtilService.viewReportButtonHandlers.packageAuditLevelReport = () => {
            ModalService.showCreateReportModal(ReportViewService.PACKAGE_AUDIT_LEVEL_REPORT, (reportOptions) => {
                reportOptions.filterCriteria = SearchFilterService.searchCriteria;
                ReportViewService.startReportWorkflow(ReportViewService.PACKAGE_AUDIT_LEVEL_REPORT, reportOptions);
            }, true);
        };


		$scope.$on('$destroy', function () {
			NavbarUtilService.viewSearchFunction = null;
			NavbarUtilService.viewFilterBtnHandler = null;
			NavbarUtilService.viewReportButtonHandlers = {
				deliveryReport: null,
				packageMediaReport: null,
				packageReport: null,
				packageMetadataReport: null
			};
		});

		$scope.$watch(function () {
			return PackageActionService.actionsLoading;
		}, function () {
			self.showActionsLoading = PackageActionService.actionsLoading;
		});

		SearchFilterService.populateCriteriaFromLocationSearch();
		getPackagePermissions();

		self.openVideoModal = function (video) {
			if (self.pmPerms.preview.read) {
                self.loadingIndicator.show = true;

                DownloadAssetService.getAssetUri(
			        video.assetId,
                    DownloadAssetService.AssetType.Video,
                    DownloadAssetService.ContentUse.Proxy
                ).then((proxyUriInfo) => {
                    video.mediaPath = proxyUriInfo.uri;
                    ModalService.showMediaModal('video', video);
                }).finally(() => {
                    self.loadingIndicator.show = false;
                });
			}
		};
	});
